import styled from 'styled-components';

export const MarkersLabel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right:20px;
`